// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { OwnerPaymentGatewayFragment } from '../../fragments/generated/owner-payment-gateway.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetActiveOwnerPaymentGatewaysQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetActiveOwnerPaymentGatewaysQueryResult = { __typename?: 'Query', getActiveOwnerPaymentGateways: Array<{ __typename?: 'OwnerPaymentGatewayDTO', id: number, description: string | null }> };

export const GetActiveOwnerPaymentGatewaysGql = gql`
    query GetActiveOwnerPaymentGateways {
  getActiveOwnerPaymentGateways {
    ...OwnerPaymentGateway
  }
}
    ${OwnerPaymentGatewayFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActiveOwnerPaymentGatewaysInjectable extends Apollo.Query<GetActiveOwnerPaymentGatewaysQueryResult, GetActiveOwnerPaymentGatewaysQueryVariables> {
    override document = GetActiveOwnerPaymentGatewaysGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */